// extracted by mini-css-extract-plugin
export default {"SuccessState":"styles_SuccessState__I2OGk","sticky":"styles_sticky__OyFdE","body":"styles_body__cL7sO","content":"styles_content__SI01m"};